import { Transition } from 'framer-motion';

// ====================================
// ⚡ FRAMER MOTION TRANSITIONS
// 애니메이션 타이밍 및 이징
// ====================================

// -------------------------------------
// Fade Transitions
// -------------------------------------

export const fadeTransition: Transition = {
	duration: 0.15,
};

export const fadeSlowerTransition: Transition = {
	duration: 0.25,
};

// -------------------------------------
// Modal Transitions
// -------------------------------------

export const modalOverlayTransition: Transition = {
	duration: 0.3,
};

export const modalContentTransition: Transition = {
	duration: 0.4,
	ease: 'easeOut',
};

// -------------------------------------
// Dropdown Transitions
// -------------------------------------

export const dropdownTransition: Transition = {
	duration: 0.2,
	ease: 'easeOut',
};

// -------------------------------------
// Slide Transitions
// -------------------------------------

export const slideUpTransition: Transition = {
	duration: 0.5,
	ease: 'easeOut',
};

export const slideDownTransition: Transition = {
	duration: 0.3,
	ease: 'easeOut',
};

export const slideLeftTransition: Transition = {
	duration: 0.3,
	ease: 'easeOut',
};

export const slideRightTransition: Transition = {
	duration: 0.3,
	ease: 'easeOut',
};

export const slideHorizontalTransition: Transition = {
	duration: 0.15,
};

// -------------------------------------
// Scale Transitions
// -------------------------------------

export const scaleTransition: Transition = {
	duration: 0.3,
	ease: 'easeOut',
};

export const scaleSpringTransition: Transition = {
	type: 'spring',
	damping: 20,
	stiffness: 300,
};
